import { render } from "./organisation-lookup-modal.vue?vue&type=template&id=d0368180&scoped=true"
import script from "./organisation-lookup-modal.vue?vue&type=script&lang=js"
export * from "./organisation-lookup-modal.vue?vue&type=script&lang=js"

import "./organisation-lookup-modal.vue?vue&type=style&index=0&id=d0368180&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-d0368180"]])

export default __exports__